import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class ModalService {

  private modalSubject = new Subject<{ type: string; title: string; message: string }>();
  public modal$ = this.modalSubject.asObservable();

  showSuccessModal(title: string, message: string) {
    this.modalSubject.next({ type: 'success', title, message });
  }

  showErrorModal(title: string, message: string) {
    this.modalSubject.next({ type: 'error', title, message });
  }

  showInfoModal(title: string, message: string) {
    this.modalSubject.next({ type: 'info', title, message });
  }

  showWarningModal(title: string, message: string) {
    this.modalSubject.next({ type: 'warning', title, message });
  }

}
